import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  FilterLiveSearch,
  SelectInput,
  DateInput,
  BooleanInput,
  TopToolbar,
  CreateButton,
  ExportButton,
  useRecordContext,
} from 'react-admin';
import { Chip } from '@mui/material';
import { createEmptyStateComponent } from '../../components/createEmptyStateComponent';

const inspectionTypes = [
  { id: 'ANNUAL', name: 'Annual Inspection' },
  { id: 'CVOR', name: 'CVOR Inspection' },
  { id: 'DOT', name: 'DOT Inspection' },
  { id: 'PRE_TRIP', name: 'Pre-Trip Inspection' },
  { id: 'POST_TRIP', name: 'Post-Trip Inspection' },
  { id: 'SAFETY', name: 'Safety Inspection' },
  { id: 'EMISSION', name: 'Emission Test' },
  { id: 'OTHER', name: 'Other' },
];

const PassedField = () => {
  const record = useRecordContext();
  if (record?.passed === undefined) {
    return null;
  }

  return (
    <Chip
      label={record.passed ? 'PASSED' : 'FAILED'}
      color={record.passed ? 'success' : 'error'}
      size="small"
    />
  );
};

const InspectionEmptyState = createEmptyStateComponent('inspections');

const InspectionListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

const inspectionFilters = [
  <FilterLiveSearch key="search" source="inspector" placeholder="Search by inspector..." />,
  <SelectInput
    key="type"
    source="inspectionType"
    choices={inspectionTypes}
    label="Inspection Type"
    alwaysOn
  />,
  <DateInput key="date" source="inspectionDate" label="Inspection Date" />,
  <BooleanInput key="passed" source="passed" label="Passed Only" />,
];

export const EquipmentInspectionList = () => (
  <List
    perPage={25}
    sort={{ field: 'inspectionDate', order: 'DESC' }}
    filters={inspectionFilters}
    actions={<InspectionListActions />}
    empty={<InspectionEmptyState />}
  >
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="id" sortable={false} />
      <ReferenceField source="equipmentId" reference="equipment">
        <TextField source="name" />
      </ReferenceField>
      <DateField source="inspectionDate" />
      <TextField source="inspectionType" />
      <TextField source="inspector" />
      <TextField source="inspectionNumber" />
      <PassedField />
      <DateField source="nextDueDate" />
      <DateField source="createdAt" />
    </Datagrid>
  </List>
);
